module.exports = "<mpf-loading *ngIf=\"loading\" message=\"{{ 'EDITOR_LOADING' | translate }}\"></mpf-loading>\n\n<div class=\"container\" *ngIf=\"!loading\">\n  <div id=\"mapify-logo\" onclick=\"window.location.href = 'https://mapeo.ch/'\"></div>\n  <mpf-settings-toggle></mpf-settings-toggle>\n\n  <mpf-map-container [map]=\"map\" [mapSize]=\"map.size\"> </mpf-map-container>\n\n  <mpf-map-configurator [map]=\"map\"></mpf-map-configurator>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/app/components/editor/editor.component.html
// module id = ../../../../../src/app/components/editor/editor.component.html
// module chunks = main